import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import {
  IBudgetAllocForm,
  MyPurchaseForm,
} from 'src/app/shared/models/app-models';
import { BudgetForm } from '../add-item-page.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { BudgetTableAction,BudgetListingTableComponent } from './budget-listing-table/budget-listing-table.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { AddBudgetComponent } from './add-budget/add-budget.component';
import { PROJECT_COMPLETION_MESSAGE } from 'src/app/modules/shared/constants';
import { BackendApiService } from 'src/app/core/services/backend-api';

export interface SelectOption {
  id: boolean;
  value: string;
  disabled?: boolean
}

export interface BudgetCount {
  capital: number;
  project: number;
  capitalAuc: number;
  operating: number;
}
@Component({
  selector: 'app-item-budget',
  templateUrl: './item-budget.component.html',
  styleUrls: ['./item-budget.component.scss'],
})
export class ItemBudgetComponent implements OnInit, OnDestroy, OnChanges {
  @Input() BudgetForm!: BudgetForm;
  @Input() isReadOnly: boolean = false;
  @Output() updateBudgetForm = new EventEmitter();
  @ViewChild('addBudgetPopUp') budgetPopUp!: MatSidenav;
  @ViewChild('popUp') formPopUp!: AddBudgetComponent;
  @ViewChild(BudgetListingTableComponent) budgetListingComponent!: BudgetListingTableComponent;
  @Output() budgetTypeValue = new EventEmitter();
  isProjectNearCompletionSelected: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  addBudgetAllocForm!: FormGroup;
  popUpBudgetAllocForm!: FormGroup;
  popUpActionType: string = 'Add';
  projectCompletionMessage = PROJECT_COMPLETION_MESSAGE
  budgetAllocationData: IBudgetAllocForm[] = [];
  budgetInitialState: IBudgetAllocForm = {
    iBudgetId: 0,
    BudgetItemId: null,
    Quantity: null,
    BudgetType: { id: '', value: '' },
    CostCentre: null,
    GLAcc: null,
    OrderNo: null,
    Percentage: null,
    FundCentre: null,
    ProjectBudget: null,
    BudgetExpenditureUsage: null,
    BudgetFrequencyUsage: null,
    ProjectCode: null,
    PurchaseItemNo: null,
    displayPurchaseItemNumber: null,
    ApprovingOfficer: null,
    isDeleted: false,
    Strikethrough: false
  };
  isSingleBudget: boolean = true;
  isQuantity: boolean = true;
  errorMsg: string = '';
  autoSet: boolean = true;
  mode: string = 'add';
  itemNo: number | null = null;
  budgetCount: BudgetCount = {
    capital: 0,
    project: 0,
    capitalAuc: 0,
    operating: 0,
  };
  toAddBudget:any={
    BudgetType: null,
    mode: 'Add',
    row: null,
  }
  constructor(
    private _fb: FormBuilder,
    private store: Store<{ form: MyPurchaseForm }>,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogComponent>,
    private backendService: BackendApiService
  ) {
    // instantiate forms
    this.addBudgetAllocForm = this._fb.group(this.budgetInitialState);
    this.popUpBudgetAllocForm = this._fb.group(this.budgetInitialState);

    // set the mode for this component
    this.mode = this.route.snapshot.params['itemNo'] ? 'edit' : 'add';
    if (this.mode === 'edit') {
      this.itemNo = this.route.snapshot.params['itemNo'];
    }
  }
  ngOnInit(): void {
    this.addBudgetAllocForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((form) => {
        this.BudgetForm.singleBudget = { ...form, Percentage: 100 };
        this.BudgetForm.isSingleBudget = true;
      });
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form) => {
        if (form.ItemList.length !== 0) {
          this.isSingleBudget = this.itemNo == null ? true : form.ItemList[this.itemNo - 1].AddItems.isSingleBudget;
          this.BudgetForm.isSingleBudget = this.isSingleBudget
          if (this.isSingleBudget && this.itemNo !== null && form.ItemList[this.itemNo - 1].BudgetAllocation.filter(x => !x.isDeleted && !x.Strikethrough).length == 1) {
            let singleBudget = form.ItemList[this.itemNo - 1]?.BudgetAllocation.find(x => x.Percentage == 100 && !x.isDeleted && !x.Strikethrough)
            if (singleBudget) this.addBudgetAllocForm.setValue(singleBudget)
          }

          this.BudgetForm.budgetList = this.itemNo == null ? [] : form.ItemList[this.itemNo - 1].BudgetAllocation.slice();
          // check if multi budget is based on quantity or percentage
          this.isQuantity = this.areBudgetAllocationsQuantity(this.BudgetForm.budgetList);
          this.updateBudgetCount();
        }
      });
  }
  areBudgetAllocationsQuantity(budgetAllocations: IBudgetAllocForm[]) {
    let isPercentage: boolean = true
    for (const budgetAllocation of budgetAllocations) {
      if (!((budgetAllocation.Quantity == 0 || budgetAllocation.Quantity == null) && budgetAllocation.Percentage && budgetAllocation.Percentage > 0))
        isPercentage = false
    }
    return (!isPercentage)
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['BudgetForm']) {
      this.updateBudgetCount();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onNumberOfBudgetChange(event: any) {
    console.log('onNumberOfBudgetChange', event)
    // toggle from multi to single
    if (event.value == true) {
      this.BudgetForm.isSingleBudget = true;
    }
    // toggle from single to multi
    else if (event.value == false) {
      this.BudgetForm.isSingleBudget = false;
    }
  }

  onUnitOfDistibutionChange(event: any) {
    let isBudgetAllocated = this.BudgetForm.budgetList.filter((item) => !item.isDeleted && !item.Strikethrough);
    if (isBudgetAllocated.length > 0) {
      this.openDeleteDialog();
    } else {
      this.clearBudget();
    }
  }
  handleBudgetTypeChange(event: any) {
    this.budgetTypeValue.emit(event)
  }
  openSideNav(event: BudgetTableAction) {
    if (event.mode == 'delete') {
      this.updateBudgetCount();
      return;
    }
    // reset from before opening form
    console.log(event, 'emitter from table');
    this.formPopUp.setControlValueFromRow(event);
    this.formPopUp.handleBudgetTypeOptions();
    this.popUpActionType = event.mode;
    this.budgetPopUp.open();
    if(event.mode=='Add'){
      this.budgetListingComponent.updateTable();
    }
  }

  openDeleteDialog() {
    this.dialogRef = this.dialog.open(DialogComponent, {
      // height: '200px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      disableClose: true,
      data: {
        headerTitle:
          'Doing so will discard all Budgets. Are you sure you want to continue?',
        contentMsg: 'This action cannot be undone.',
        btnNameOne: 'Discard',
        btnNameTwo: 'Cancel',
        click: () => {
          this.clearBudget();
          this.dialogRef.close();
        },
        clickTwo: () => {
          this.isQuantity = !this.isQuantity;
          this.dialogRef.close();
        },
      },
    });
  }

  clearBudget() {
    let newBudgetList: IBudgetAllocForm[] = [];
    for (const budget of this.BudgetForm.budgetList) {
      newBudgetList.push({ ...budget, isDeleted: true });
    }
    this.BudgetForm.budgetList = newBudgetList;
    this.BudgetForm.singleBudget = this.BudgetForm.singleBudget
      ? { ...this.BudgetForm.singleBudget, isDeleted: true }
      : null;
    this.updateBudgetForm.emit(this.BudgetForm);
  }

  closeNav(event: any) {
    if (event) {
      this.updateBudgetForm.emit(event);
      this.budgetPopUp.close();
    }
  }

  updateBudgetCount() {
    this.budgetCount.capital = this.BudgetForm.budgetList.filter(
      (budget) => budget.BudgetType.id == 'Capital' && !budget.isDeleted
    ).length;
    this.budgetCount.capitalAuc = this.BudgetForm.budgetList.filter(
      (budget) => budget.BudgetType.id == 'Capital AUC' && !budget.isDeleted
    ).length;
    this.budgetCount.operating = this.BudgetForm.budgetList.filter(
      (budget) => budget.BudgetType.id == 'Operating' && !budget.isDeleted
    ).length;
    this.budgetCount.project = this.BudgetForm.budgetList.filter(
      (budget) => budget.BudgetType.id == 'Project' && !budget.isDeleted
    ).length;
    this.updateProjectCompletionMessage()

  }
  async updateProjectCompletionMessage() {
    let budgets = this.BudgetForm.budgetList.filter(
      (budget) => budget.BudgetType.id == 'Project' && !budget.isDeleted && !budget.Strikethrough
    )
    let flag = false
    for (const record of budgets) {
      if (!record.ProjectCode) return
      const resp: any = await lastValueFrom(this.backendService.getProjectVoteInfo(record.ProjectCode.id))
      if (resp.hashLastMinuteProjectEqupmentPurchase) {
        flag = true
      }
    }
    this.isProjectNearCompletionSelected = flag
  }

  showProjectCompletionMessage(value: boolean) {
    this.isProjectNearCompletionSelected = value
  }
}
